var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var drawHoleDataTo2D = require("./../../../shared/index.js").drawHoleDataTo2D;
var colors = require("./../../../shared/index.js").colors;

var PadInteractionView = function (gui, interactionModel, parentGroup, layers) {
    var self  = this;

    this.gui = gui;
    this.interactionModel = interactionModel;
    this.data = interactionModel.data;
    this.editorModel = interactionModel.editorModel;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.copperTop, layers.copperTopControl,
                                  layers.copperInner, layers.copperInnerControl,
                                  layers.copperBottom, layers.copperBottomControl,
                                  layers.soldermaskTop, layers.soldermaskTopControl,
                                  layers.solderpasteTop, layers.solderpasteTopControl,
                                  layers.solderpasteBottom, layers.solderpasteBottomControl,
                                  layers.soldermaskBottom, layers.soldermaskBottomControl,
                                  layers.drill, layers.drillControl]);

    this.copperTopGroup = this.getGroupInfo(layers.copperTop).svgGroup;
    this.copperTopControlGroup = this.getGroupInfo(layers.copperTopControl).svgGroup;
    this.copperInnerGroup = this.getGroupInfo(layers.copperInner).svgGroup;
    this.copperInnerControlGroup = this.getGroupInfo(layers.copperInnerControl).svgGroup;
    this.copperBottomGroup = this.getGroupInfo(layers.copperBottom).svgGroup;
    this.copperBottomControlGroup = this.getGroupInfo(layers.copperBottomControl).svgGroup;

    this.soldermaskTopGroup = this.getGroupInfo(layers.soldermaskTop).svgGroup;
    this.soldermaskTopControlGroup = this.getGroupInfo(layers.soldermaskTopControl).svgGroup;
    this.soldermaskBottomGroup = this.getGroupInfo(layers.soldermaskBottom).svgGroup;
    this.soldermaskBottomControlGroup = this.getGroupInfo(layers.soldermaskBottomControl).svgGroup;

    this.solderpasteTopGroup = this.getGroupInfo(layers.solderpasteTop).svgGroup;
    this.solderpasteTopControlGroup = this.getGroupInfo(layers.solderpasteTopControl).svgGroup;
    this.solderpasteBottomGroup = this.getGroupInfo(layers.solderpasteBottom).svgGroup;
    this.solderpasteBottomControlGroup = this.getGroupInfo(layers.solderpasteBottomControl).svgGroup;

    this.drillGroup = this.getGroupInfo(layers.drill).svgGroup;
    this.drillControlGroup = this.getGroupInfo(layers.drillControl).svgGroup;

    $(this.copperTopControlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    $(this.copperInnerControlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    $(this.copperBottomControlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    $(this.soldermaskTopControlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    $(this.soldermaskBottomControlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    $(this.solderpasteTopControlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    $(this.solderpasteBottomControlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    $(this.drillControlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    this.draw();

    this.interactionModel.selected.onChange(self, function(value){
        self.setSelected(value);
    },10);

    var scheduleRedraw = function(){
        self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    };

    this.interactionModel.infocus.onChange("interaction view", scheduleRedraw);
    this.data.onBubble(this, scheduleRedraw);
    this.cameraModel.viewS.onChange(this, scheduleRedraw);
};
lib_core.mixin(PadInteractionView, editor_2d.DrawingElement);

module.exports = PadInteractionView;

PadInteractionView.prototype.draw = function() {
    var self = this;

    if (!this.data.isAlive()) return;

    // draw visible
    var attrs = {
        transform: editor_2d.toSVGutil.rotateTransform(this.data) + editor_2d.toSVGutil.translateTransform(this.data),
    };

    this.drawCopper();
    this.drawHole(attrs);
    this.drawSoldermask();
    this.drawSolderpaste();
};

PadInteractionView.prototype.drawCopper = function () {
    $(this.copperTopControlGroup).empty();
    $(this.copperTopGroup).empty();
    $(this.copperInnerControlGroup).empty();
    $(this.copperInnerGroup).empty();
    $(this.copperBottomControlGroup).empty();
    $(this.copperBottomGroup).empty();

    if (this.data.getTopCopper()) {
        var g = this.gui.svg.group(this.copperTopGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getTopCopper());
        var padView = $(this.copperTopGroup.children).last();
        if(this.data.getHole()){
            padView.attr("fill", colors.terminalFill).attr("stroke", colors.terminalFill)
        }

        // draw control rectangle
        var g = this.gui.svg.group(this.copperTopControlGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getTopCopper());
        var pad = $(this.copperTopControlGroup.children).last();
        pad.attr("stroke-width", 4 / this.cameraModel.viewS()); // make control a little larger

    }

    if (this.data.getInnerCopper()) {
        var g = this.gui.svg.group(this.copperInnerGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getInnerCopper());
        var padView = $(this.copperInnerGroup.children).last();
        if(this.data.getHole()){
            padView.attr("fill", colors.terminalFill).attr("stroke", colors.terminalFill)
        }

        // draw control rectangle
        var g = this.gui.svg.group(this.copperInnerControlGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getInnerCopper());
        var pad = $(this.copperInnerControlGroup.children).last();
        pad.attr("stroke-width", 4 / this.cameraModel.viewS()); // make control a little larger
         
    }

    if (this.data.getBottomCopper()) {
        var g = this.gui.svg.group(this.copperBottomGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getBottomCopper());
        var padView = $(this.copperBottomGroup.children).last();
        if(this.data.getHole()){
            padView.attr("fill", colors.terminalFill).attr("stroke", colors.terminalFill)
        }

        // draw control rectangle
        var g = this.gui.svg.group(this.copperBottomControlGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getBottomCopper());
        var pad = $(this.copperBottomControlGroup.children).last();
        pad.attr("stroke-width", 4 / this.cameraModel.viewS()); // make control a little larger
        
    }
};

PadInteractionView.prototype.drawHole = function () {
    $(this.drillGroup).empty();
    $(this.drillControlGroup).empty();

    if (this.data.getHole()) {
        var g = this.gui.svg.group(this.drillGroup);
        drawHoleDataTo2D(this.gui.svg, g, this.data.getHole());
        var padView = $(this.drillGroup.children).last();
        if(this.data.getHole()){
            padView.attr("fill", colors.hole).attr("stroke", colors.hole)
        }
        var g = this.gui.svg.group(this.drillControlGroup);
        drawHoleDataTo2D(this.gui.svg, g, this.data.getHole());
        var drill = $(":nth-last-child(1)",this.drillControlGroup);
        drill.attr("stroke-width", 4 / this.cameraModel.viewS()); // make control a little larger
    }
};

PadInteractionView.prototype.drawSoldermask = function () {
    $(this.soldermaskTopGroup).empty();
    $(this.soldermaskTopControlGroup).empty();
    $(this.soldermaskBottomGroup).empty();
    $(this.soldermaskBottomControlGroup).empty();

    if (this.data.getTopSolderMask()) {
        var g = this.gui.svg.group(this.soldermaskTopGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getTopSolderMask());
        var g = this.gui.svg.group(this.soldermaskTopControlGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getTopSolderMask());
    }
    if (this.data.getBottomSolderMask()) {
        var g = this.gui.svg.group(this.soldermaskBottomGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getBottomSolderMask());
        var g = this.gui.svg.group(this.soldermaskBottomControlGroup);
        editor_2d.drawShapeDataTo2D(this.gui.svg, g, this.data.getBottomSolderMask());
    }
};

PadInteractionView.prototype.drawSolderpaste = function () {
    $(this.solderpasteTopGroup).empty();
    $(this.solderpasteTopControlGroup).empty();
    $(this.solderpasteBottomGroup).empty();
    $(this.solderpasteBottomControlGroup).empty();

    var self = this;
    var topSolderPaste = this.data.getTopSolderPaste();
    var bottomSolderPaste = this.data.getBottomSolderPaste();

    if (topSolderPaste) {
        if(!Array.isArray(topSolderPaste)) topSolderPaste = [].concat(topSolderPaste);

        topSolderPaste.forEach(function(geo) {
            var g = self.gui.svg.group(self.solderpasteTopGroup);
            editor_2d.drawShapeDataTo2D(self.gui.svg, g, geo);
            var g = self.gui.svg.group(self.solderpasteTopControlGroup);
            editor_2d.drawShapeDataTo2D(self.gui.svg, g, geo);
        });
    }

    if (bottomSolderPaste) {
        if(!Array.isArray(bottomSolderPaste)) bottomSolderPaste = [].concat(bottomSolderPaste);

        bottomSolderPaste.forEach(function(geo) {
            var g = self.gui.svg.group(self.solderpasteBottomGroup);
            editor_2d.drawShapeDataTo2D(self.gui.svg, g, geo);
            var g = self.gui.svg.group(self.solderpasteBottomControlGroup);
            editor_2d.drawShapeDataTo2D(self.gui.svg, g, geo);
        });
    }
};

PadInteractionView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
            .fromJSEvent(event)
            .element( this.interactionModel )
            .data( 'mouseCoord', this.gui.relativeMouseCoord(event) );

    return this.gui.stateMachine.handle(cEvent);
};
